import { Box } from '@mui/material'
import React, { ReactNode, useState } from 'react'
import Footer from './Footer'
import Header from './Header'
import Sidebar from './Sidebar'

interface propTypes {
  children: ReactNode
}
const Layout: React.FC<propTypes> = ({ children }) => {
  const [openSidebar, setOpenSidebar] = useState<boolean>(false)

  const handleSidebar = () => {
    setOpenSidebar(!openSidebar)
  }
  const closeSidebar = () => {
    setOpenSidebar(false)
  }
  return (
    <>
      <Header handleSidebar={handleSidebar} openSidebar={openSidebar} />
      <Sidebar openedSidebar={openSidebar} closeSidebarHanlder={closeSidebar} />
      <Box
        sx={{
          mt: { xs: '56px', md: '65px' },
        }}
      >
        {children}
      </Box>
      <Footer />
    </>
  )
}

export default Layout
